import Axios from 'axios';
import { setPreloader } from '../../../utils/setPreloader';
import { makeUrl } from '../../../utils/makeUrl';
import { scrollTo } from '../../../utils/scroll';
import { getProductData } from '../utils/data';

const renderSizeColumn = (hasSizeColumn, filesize) => {
    if (hasSizeColumn) {
        return `<span class="popup-table-column">${
            // eslint-disable-next-line no-restricted-globals
            (filesize !== 'Size' && isNaN(filesize)) || parseFloat(filesize) === 0 ? '' : filesize
        }</span>`;
    }

    return '';
};

const renderItem = (
    { fileName, linkDisplayName, fileType, filesize, updatedOn, link },
    translations,
    hasSizeColumn
) => {
    const linkFileName = fileName || '';
    return `<div class="popup-table-row ">
        <div class="popup-table-column">
            <div class="wrapper-file-icon">
                <svg class="icon icon_pdf_ic ">
                    <use xlink:href="#crtf_ic"></use>
                </svg>
            </div>
            <div>${linkDisplayName !== null ? linkDisplayName : linkFileName}</div>
        </div>
        <span class="popup-table-column">${fileType || ''}</span>
        ${renderSizeColumn(hasSizeColumn, filesize)}
        <span class="popup-table-column">${updatedOn}</span>
        <span class="popup-table-column">
            <div class="download-btn-wrapper"><a class="download-link btn-se btn-se_color_blue"
            href="${link}${linkFileName}" download>${translations['pdp.label.download']}</a></div>
        </span>
    </div>
    `;
};

const renderTemplate = ({ pic, partnumber, name, translations, downloadLinks }) => {
    const hasSizeColumn = downloadLinks.some(
        item => parseFloat(item.filesize) && parseFloat(item.filesize) !== 0
    );

    return `
        <div class="popup-header">
            <div class="popup-header__img-wrapper">
                <img class="popup-header__img" src="${pic}" />
            </div>
            <div class="popup-header-content">
                <div class="popup__product-name">${name}</div>
                <span class="popup-sku">${partnumber}</span>
            </div>
        </div>
        <div class="popup-content__files-content">
            <div class="content-header">${translations['finder.software.availableVersions']}</div>
            <div class="${
                hasSizeColumn ? 'popup-table' : 'popup-table popup-table_without-size-column'
            }">
                <div class="popup-table-row popup-table-row_head-row">
                    <div class="popup-table-column">${
                        translations['software.download.fileTitle']
                    }</div>
                    <div class="popup-table-column">${
                        translations['software.download.fileType']
                    }</div>
                    ${renderSizeColumn(hasSizeColumn, translations['software.download.fileSize'])}
                    <div class="popup-table-column">${translations['software.updatedOn']}</div>
                    <div class="popup-table-column"></div>
                </div>
                ${downloadLinks.map(item => renderItem(item, translations, hasSizeColumn)).join('')}
            </div>
        </div>
    `;
};

const popupWrapper = document.querySelector('.popup-wrapper');
const popupContent = document.querySelector('.popup-content');

function closePopup() {
    document.body.classList.remove('modal-open');
    popupWrapper.style.display = 'none';
}

export const findDomElementUp = (el, predicate) =>
    predicate(el)
        ? el
        : (el.parentElement && findDomElementUp(el.parentElement, predicate)) || null;

popupWrapper.addEventListener('click', ({ target }) => {
    if (
        findDomElementUp(target, el => el.classList.contains('popup-close')) ||
        !findDomElementUp(target, el => el.classList.contains('popup'))
    ) {
        closePopup();
    }
});
window.addEventListener('keydown', e => {
    if (e.keyCode === 27 && document.body.classList.contains('modal-open')) {
        closePopup();
    }
});

export const makePopup = downloadData => {
    popupWrapper.style.display = 'block';
    document.body.classList.add('modal-open');
    scrollTo({ element: popupWrapper, direction: 'top' }, 0, { duration: 0 });
    popupContent.innerHTML = renderTemplate(downloadData);
};

export function downloadHandler(e) {
    e.preventDefault();
    const commonData = this.dataset;
    const preloader = setPreloader(this);
    const url = makeUrl(
        `/rest/model/schneider/catalog/CatalogLookupActor/softwareDownloads?skuId=SKU-${
            this.dataset.partnumber
        }&pushSite=${getProductData().siteId}`
    );
    Axios.get(url).then(res => {
        const dataForDownloadPopup = { ...res.data, ...commonData };
        makePopup(dataForDownloadPopup);
        preloader.destroy();
    });
}
